import { formHelperTextClasses, type Theme } from "@mui/material"
import { CustomTextFieldTheme } from "core/themes/src/definitions/components.types"

export const createCustomTextFieldTheme = (_: Theme): CustomTextFieldTheme => ({
    styleOverrides: {
        root: {
            [`.${formHelperTextClasses.root}`]: {
                [`&.${formHelperTextClasses.contained}`]: {
                    [`&.${formHelperTextClasses.error}`]: {
                        [`&.${formHelperTextClasses.focused}`]: {
                            display: "block",
                        },
                    },
                },
            },
            "&:hover": {
                [`.${formHelperTextClasses.root}`]: {
                    [`&.${formHelperTextClasses.contained}`]: {
                        [`&.${formHelperTextClasses.error}`]: {
                            display: "block",
                        },
                    },
                },
            },
            ".CustomTextField-errorIcon": {
                pointerEvents: "none",
            },
        },
    },
})
